import {AppFunction} from "../misc/types";
import View from "../framework/view";
import Server, {PingResult} from "../server";
import template from "../../pugc/about";
import jQuery from "jquery";
import {toCanvas} from "qrcode";
import build_config from "../../../../server/build/wrb_build_config";
import {AddOrderView} from "../views/add_order";

export class AboutFunction extends AppFunction {

    readonly v : View;

    constructor(admin: boolean) {
        super();
        this.v = new AboutView(admin);
    }

    view() {
        return this.v;
    }
    url() {
        return "/about";
    }

    offlineEnabled() {
        return true;
    }
}

class AboutView extends View {

    static classname = "about-view";

    private serverVersion? : PingResult;

    readonly clientVersion : PingResult = {
        commit: build_config.git_commit,
        branch: build_config.git_branch,
        version: build_config.git_version,
    };

    private readonly admin : boolean;

    private readonly server = Server.instance();

    private shortUrl? : string;

    private gcData?: {max: number, used: number};

    constructor(admin: boolean) {
        super(AboutView.classname);

        this.admin = admin;

        Server.instance().ping("about").then((p) => {
            this.serverVersion = p;
            this.update();
        })

        this.server.getShortBaseUrl().then((url) => {
            this.shortUrl = url;
            this.update();
        });
    }

    protected render0(): JQuery<HTMLElement> {

        const trunc = function(s?: string) {
            return s ? s.substring(0, 8) : "";
        }

        const branch = function(b?: string) {
            return b && b != "master" ? b : "";
        }

        const data = {
            baseUrl: this.server.getBaseUrl(),
            shortUrl: this.shortUrl,
            trunc: trunc,
            branch: branch,
            clientVersion: this.clientVersion,
            serverVersion: this.serverVersion,
            gcData: this.gcData,
            admin: this.admin,
        };

        const out = this.pug(template, data);

        if (this.shortUrl) {
            this.afterUpdate(() => {
                const width = this.elt().find(".qrcode").width();
                const canvases = this.elt().find("canvas");
                canvases.each((idx, c) => {
                    const canvas = jQuery(c);
                    const url = canvas.data("url");
                    console.log("canvas width ", width);
                    toCanvas(c, url, {
                        errorCorrectionLevel: "high",
                        width: width
                    }, (err) => console.log(err))
                });
            });
        }

        return out;
    }

    async gc() {
        const s = Server.instance();
        this.gcData = await s.gc();
        this.update();
    }
}



View.on(
    "." + AboutView.classname,
    "click",
    ".gc",
    function(that: AboutView, event, elt) {
        event.preventDefault();
        that.gc();
    });

